module.exports = __webpack_public_path__ + "static/media/searchIconDesk.564d3327.svg";